/**
 * Clear all user-specific data from localStorage.
 * Called on both voluntary logout and forced logout (401/403).
 *
 * Using localStorage.clear() because no keys need to survive across sessions.
 * If a key ever needs to persist (e.g., theme), switch to explicit removeItem() calls.
 *
 * Keys cleared: owner_scope, defaultCurrency, forecast_cache_v2_*,
 * customerColumnIds, customerColumnOrder, collapsed
 */
export const clearUserData = () => {
  localStorage.clear();
};
